import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User selected a brand context to apply to a share link design',
  name: 'brand_context_selected',
  params: [
    {
      description: 'Name of the brand context that was selected',
      name: 'brand_context_name',
      required: true,
      type: 'string',
    },
    {
      description: 'Type of share link the brand context was applied to',
      name: 'share_link_type',
      required: true,
      type: 'enum',
      values: ['board', 'collection'],
    },
  ],
};

export default META;
